import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { ReactComponent as UploadDropIcon } from './assets/upload-drop-icon.svg';
import { ReactComponent as UploadIcon } from './assets/upload-icon.svg';
import { Button } from '../../../../ds';
import './dropZone.scss';

const DropZone = ({ onFilesChange }) => {
  const [isDragActive, setIsDragActive] = useState(false);
  const fileInputRef = React.useRef(null);

  const handleDrag = event => {
    event.preventDefault();
    event.stopPropagation();
    if (event.type === 'dragenter' || event.type === 'dragover') {
      setIsDragActive(true);
    } else if (event.type === 'dragleave') {
      setIsDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onFilesChange(e.dataTransfer.files);
    }
  };

  const handleChange = function (e) {
    e.preventDefault();

    if (e.target.files && e.target.files[0]) {
      onFilesChange(e.target.files);
      e.target.value = '';
    }
  };

  const openFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <div
      onDragEnter={handleDrag}
      className={`drop-zone ${isDragActive ? 'drop-zone-activate' : ''}`}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <form
        className='drop-zone-content'
        onDragEnter={handleDrag}
        onSubmit={e => e.preventDefault()}
      >
        <input
          ref={fileInputRef}
          type='file'
          className='drop-hidden-input'
          multiple={true}
          onChange={handleChange}
        />
        <Button
          type='link'
          className='drop-zone--upload-link'
          onClick={openFileInput}
        >
          Adjuntar archivo
        </Button>
        <div className='drop-zone-upload-icon'>
          <UploadIcon className='k-ds-m-bottom-sp-04' />
          <div className='k-ds-body-02'>Arrastra archivo .xlsx</div>
        </div>
        <div className='draggin-upload'>
          <UploadDropIcon className='draggin-upload-icon' />
        </div>
      </form>
    </div>
  );
};

DropZone.propTypes = {
  onFilesChange: PropTypes.func,
  onDragActiveChange: PropTypes.func,
};

export default DropZone;
